import { SUBSCRIBED, UNSUBSCRIBED } from 'constants/userForms';
import { appConfig } from 'config/customization';

export const retrieveDigitalBillAdherenceStatus = account => {
  if (appConfig.userDigitalBillAdherence) {
    if (account.user_adherence_to_digital_bill) return SUBSCRIBED;
    return UNSUBSCRIBED;
  }
  return account.adherence_to_digital_bill;
};
